import history from './history';
import helpers from './helpers';


export default {
  login(data, cb) {
    localStorage.setItem('user', JSON.stringify(data.user));
    localStorage.setItem('token', data.token);
    localStorage.setItem('permissions', JSON.stringify(data.permissions));

    cb();
  },

  updateUserData(user, cb) {
    localStorage.setItem('user', JSON.stringify(user.user));

    cb ? cb(): '';
  },

  logout(cb) {
    if (global.socket) {
      global.socket.disconnect();
      global.socket = null;
    }

    delete localStorage.user;
    delete localStorage.token;
    delete localStorage.permissions;

    cb();
  },

  logoutAndRedirect(navigate) {
    this.logout(() => {
      navigate('/login');
    });
  },

  getUser() {
    if (!localStorage.user) return false;

    const user = helpers.getUserFromLocalStorage();

    if (user) {
      user.id = user._id;
    }

    return user;
  },

  can(rule) {
    const permissionsStr = localStorage.getItem('permissions');
    if (!permissionsStr || permissionsStr === 'undefined' || permissionsStr === 'null') {console.error("Permissions not set"); return false};

    const permissions = JSON.parse(permissionsStr);

    return permissions.indexOf(rule) !== -1;
  },

  loggedIn() {
    return !!localStorage.token;
  },
};
